import { z } from 'zod';
import { convertDelayToSeconds, getMaxDelayDescription, MAX_DELAY_SECONDS } from './delay-utils';
const LIQUID_VARIABLE_PATTERN = /\{\{[^{}]+\}\}/;
/**
 * Flow Control Delay v2 Configuration Validator Factory
 * Supports both static numeric values and liquid template variables for timeDelayValue
 * @param isToolCall - true for in-call tool workflows (10s max), false for post-call workflows (4 weeks max)
 */
export const createFlowControlDelay2ConfigValidator = (isToolCall) => {
    const maxSeconds = isToolCall ? MAX_DELAY_SECONDS.toolCall : MAX_DELAY_SECONDS.postCall;
    const maxDelayDescription = getMaxDelayDescription(isToolCall);
    return z
        .object({
        timeDelayUnit: z.enum(['seconds', 'minutes', 'hours', 'days', 'weeks'], {
            error: (issue) => issue.input === undefined
                ? 'Time delay unit is required'
                : 'Time delay unit must be one of: seconds, minutes, hours, days, weeks'
        }),
        timeDelayValue: z.string().min(1, 'Time delay value is required')
    })
        .refine((data) => {
        const { timeDelayValue } = data;
        if (LIQUID_VARIABLE_PATTERN.test(timeDelayValue))
            return true;
        const numericValue = Number(timeDelayValue);
        return !isNaN(numericValue) && numericValue >= 1 && Number.isInteger(numericValue);
    }, {
        path: ['timeDelayValue'],
        error: 'Time delay value must be a positive whole number or a variable'
    })
        .refine((data) => {
        const { timeDelayUnit, timeDelayValue } = data;
        if (LIQUID_VARIABLE_PATTERN.test(timeDelayValue))
            return true;
        const totalSeconds = convertDelayToSeconds(Number(timeDelayValue), timeDelayUnit);
        return totalSeconds <= maxSeconds;
    }, {
        path: ['timeDelayValue'],
        error: `Total delay time cannot exceed ${maxDelayDescription}`
    });
};
/**
 * Flow Control Delay v2 Configuration Validator
 * Default validator for post-call workflows (4 week max)
 */
export const Flow_Control_Delay_2_ConfigValidator = createFlowControlDelay2ConfigValidator(false);
//# sourceMappingURL=flow-control-delay-2.js.map